export interface IntakeLabel {
  label: string; //original label
  transformedLabel?: string;
  spousePartnerLabel?: string;
  abbreviationLabel?: string;
  abbreviationSpouseLabel?: string;
  alternateLabel?: string;
  alternateLabelSpouse?: string;
  replacementLabel?: string;
  helperText?: string;
  alternateHelperText?: string;
  thirdPersonLabel?: string;
  heading?: string;
  onBehalfLabel?: string;
  onBehalfSpousePartnerLabel?: string;
}

export interface IntakeLabelCollection {
  [name: string]: IntakeLabel;
}
